import React from 'react';

import EditTemplate from '../../Components/Edit';
import Erros from './Erros';
import Form from './Form';
import validate from './Validation';

const Title = ({ record }) => (
  <span>Editar Unidade de Produto: {record ? `"${record.nome}"` : ''}</span>
);

function transform({ nome, tipo, ...data }) {
  return {
    nome,
    tipo,
  };
}

const UnidadeEdit = (props) => (
  <EditTemplate
    {...props}
    title={<Title />}
    validate={validate}
    onFailure={Erros}
    transform={transform}
    isBack
  >
    <Form isCreate={false} />
  </EditTemplate>
);

export default UnidadeEdit;
